/* A single row in the AutoCompleteResults dropdown representing a search result */

import React from 'react';
import styled from 'astroturf/react';

import $image_url from 'js/utils/image_url';

const Row = styled.a<{ highlighted?: boolean }>`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 7px;
  cursor: pointer;
  width: 100%;

  &.highlighted {
    background-color: var(--brand-colors-neutral-300);
  }

  &:hover,
  &:focus,
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;

const ResultIcon = styled.div`
  border-radius: 3px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-right: 10px;
  background-color: #ccc;
  color: #fff;
`;

const EntityContent = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 12px;
  /* subtract ResultIcon width + margin to prevent overflow */
  width: calc(100% - 40px);
  padding-right: 10px;
`;

const Name = styled.span`
  font-weight: 700;
  line-height: 1.1;
  color: #000000;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

// DESIGN: gray is hard to see
const Description = styled.span`
  font-weight: 300;
  line-height: 20px;
  color: #ccc;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const ResultImage = styled.img`
  border-radius: 3px;
  width: 30px;
  height: 30px;
  margin-right: 10px;
`;

const Avatar = ({ photoUrl }: { photoUrl: string }) => {
  const url = photoUrl != null ? photoUrl : $image_url('s65_no_pic.png');
  return <ResultImage src={url} />;
};

// TODO: camelize results from controller
export type SearchResult = {
  display_name: string;
  description?: string;
  image_url?: string;
  entity_url: string;
  type: 'User' | 'ResearchInterest' | 'University' | 'Query';
  onClick?: (e: React.MouseEvent) => void;
  highlighted?: boolean;
};

const AutoCompleteResultRow = React.forwardRef<HTMLAnchorElement, SearchResult>(
  (
    {
      display_name,
      description,
      image_url,
      entity_url,
      type,
      onClick,
      highlighted,
    },
    ref,
  ) => (
    <Row
      ref={ref}
      href={entity_url}
      onClick={onClick}
      highlighted={highlighted}
    >
      {type === 'User' ? (
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
        <Avatar photoUrl={image_url} />
      ) : (
        <ResultIcon>
          {type === 'University' ? (
            <i className="fa fa-university" />
          ) : (
            <i className="fa fa-tag" />
          )}
        </ResultIcon>
      )}
      <EntityContent>
        <Name>{display_name}</Name>
        <Description>{description}</Description>
      </EntityContent>
    </Row>
  ),
);

export default AutoCompleteResultRow;
